import ApiERP from '@/core/conectores/ApiERP';
import { IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { ICstIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/ICstIbsCbs';
import { IClassificacaoIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/IClassificacaoIbsCbs';
import { IPropriedadeConsulta } from '@/core/models/Consulta/PropriedadeConsulta';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { IListaPaginada } from '@/core/models/Consulta/IListaPaginada';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
import { IParametrosConsultaRapida } from '@/core/models/Consulta/IParametrosConsultaRapida';
import { IItemConsultaRapida } from '@/core/models/Consulta/IItemConsultaRapida';
import storeSistema from '@/store/storeSistema';

class ServicoIbsCbs {
    endPoint = 'ibs-cbs';

    apiERP = new ApiERP();

    public requisicaoSistema():void {
      this.apiERP = new ApiERP(true);
    }

    public async obterPropriedadesConsulta(): Promise<IPropriedadeConsulta[]> {
      const listaPropriedades = await this.apiERP.obterPropriedadesConsulta(this.endPoint);
      return listaPropriedades;
    }

    public async buscaAvancada(parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[]): Promise<IListaPaginada> {
      return this.apiERP.buscaAvancada(this.endPoint, parametrosConsulta, filtros);
    }

    public async relatorioPadrao(tipoArquivo: ETipoArquivo, parametrosConsulta: IParametrosConsulta, filtros?: IFiltroGenerico[], codigosSelecionados?: Array<number>): Promise<IRetornoRelatorio> {
      return this.apiERP.relatorioPadrao(this.endPoint, tipoArquivo, parametrosConsulta, filtros, codigosSelecionados);
    }

    public async consultaRapida(parametrosConsultaRapida: IParametrosConsultaRapida): Promise<IItemConsultaRapida[]> {
      const parametrosAdicionais = this.apiERP.obterParametrosAdicionaisConsultaRapida(parametrosConsultaRapida);
      const result: any = await this.apiERP.get(`${this.endPoint}/consulta-rapida${parametrosAdicionais}`);
      return result.data;
    }

    public async incluirIbsCbs(objeto: ICstIbsCbs): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.post(`${this.endPoint}/empresa/${storeSistema.getters.codigoEmpresaOperacao()}`, objeto);
      return result.data;
    }

    public async incluirClassificacaoIbsCbs(objeto: IClassificacaoIbsCbs): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.post(`${this.endPoint}/classificacao`, objeto);
      return result.data;
    }

    public async alterarIbsCbs(objeto: ICstIbsCbs): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.put(`${this.endPoint}/cst/${objeto.codigo}`, objeto);
      return result.data;
    }

    public async alterarClassificacaoIbsCbs(objeto: IClassificacaoIbsCbs): Promise<IRetornoRequisicao> {
      const result: any = await this.apiERP.put(`${this.endPoint}/classificacao/${objeto.codigo}`, objeto);
      return result.data;
    }

    public async obterIbsCbs(): Promise<ICstIbsCbs[]> {
      const result: any = await this.apiERP.get(`${this.endPoint}/cst`);
      return result.data;
    }

    public async obterIClassificacaoIbsCbs(): Promise<IClassificacaoIbsCbs[]> {
      const result: any = await this.apiERP.get(`${this.endPoint}/classificacao`);
      return result.data;
    }

    public async obterPeloCodigoIbsCbs(codigoIbsCbs: number): Promise<ICstIbsCbs> {
      const result: any = await this.apiERP.get(`${this.endPoint}/cst/codigo/${codigoIbsCbs}`);
      return result.data;
    }

    public async obterPeloCodigoClassificacao(codigoClassificacao: number): Promise<IClassificacaoIbsCbs> {
      const result: any = await this.apiERP.get(`${this.endPoint}/classificacao/codigo/${codigoClassificacao}`);
      return result.data;
    }
  // #endregion
}

export default new ServicoIbsCbs();
